import {Injectable} from '@angular/core';
import {DocumentResourceApi} from "./api/document-resource.api";

@Injectable()
export class DocumentResourceService {

  constructor(private documentResourceApi: DocumentResourceApi) {
  }

  deleteDocs(documentCode) {
    return this.documentResourceApi.delete(documentCode);
  }

  downloadBenefitStatement(keyword: string, startDate: string, endDate: string, language: string) {
    return this.documentResourceApi.downloadBenefitStatement(keyword, startDate, endDate, language);
  }

  getCertificate(openNewTabStatus: boolean) {
    return this.documentResourceApi.getCertificate(openNewTabStatus);
  }

  getCertificateByKeyword(keyword: string, openNewTabStatus: boolean) {
    return this.documentResourceApi.getCertificateByKeyword(keyword, openNewTabStatus);
  }

  downloadDocument(downloadCode, filename, extension) {
    return this.documentResourceApi.download(downloadCode, filename, extension);
  }

  downloadDocumentSourceFile(formData: FormData, token) {
    return this.documentResourceApi.downloadDocumentSourceFile(formData, token);
  }

  getDocumentsByKeyword(title, selectedProductId, page, size) {
    return this.documentResourceApi.getByKeyword(title, selectedProductId, page, size);
  }

  uploadFile(formData) {
    return this.documentResourceApi.upload(formData);
  }

  uploadDocumentSourceFile(formData: FormData, token) {
    return this.documentResourceApi.uploadDocumentSourceFile(formData, token);
  }

  downloadDataDetail(downloadCode) {
    return this.documentResourceApi.downloadDataDetail(downloadCode);
  }
}
